<template>
<div class="mask-layer mask meQR">
    <div class="container">
        <div class="title">
            为了账号安全，请绑定手机号
        </div>
        <div class="content">
            <div class="form_item">
                <div class="form_left mln12">
                    <!-- <p>手机号：</p> -->
                </div>
                <div class="form_right myRight" style="width: unset!important;margin-left: 0px;padding-left: 0px;">
                    <!-- <el-input type="text" class="el_box" placeholder="请输入手机号" v-model.trim="model.phone" name="phone"></el-input> -->
                    <input type="text" class="myPhone" placeholder="请输入手机号" v-model.trim="model.phone" name="phone">
                </div>
            </div>
            <div class="form_item">
                <div class="form_left mln12">
                    <!-- <p>验证码：</p> -->
                </div>
                <div class="form_right myRight" style="width: unset!important;margin-left: 0px;padding-left: 0px;">
                    <input type="text" class="myCode" placeholder="请输入6位验证码" v-model.trim="model.code" name="code">
                    <button type="button" class="btn mr20" v-if="show" @click="getMyCode">获取验证码</button>
                    <button type="button" class="btn mr20" v-if="!show" style="background:#ccc">{{count}}s</button>
                </div>
            </div>
        </div>
        <div class="btn-wrap">
            <button type="button" class="btn mr20" @click="save">确定</button>
            <button type="button" class="btn" @click="close">取消</button>
        </div>
        <div class="close" @click="close">X</div>
    </div>
</div>
</template>

<script>
export default {
    name: "sendMessage",
    props: [
        'openId'
    ],
    data() {
        return {
            model: {
                "phone": "", // 手机号
                "code": "", // 验证码
                "openId": "" // openId 从首页轮训接口返回值获取
            },
            count: '',
            timer: null,
            show: true,
            // remark:'提醒您，为了快速处理轻微交通事故，请您登录“e处理系统”微信小程序，快捷登录请点击：https://dllzff.cn/DjEaPEO2'
            // remark:'为了快速处理轻微交通事故，请您登录“智能云闪处”微信小程序，快捷登录：https://dllzff.cn/HbUCGVWg'
        }
    },
    mounted() {
        this.model.openId = this.openId;
    },
    computed: {
        remark() {
            let miniName = this.configuration.miniName;
            let myRemark = `为了快速处理轻微交通事故，请您登录“${miniName}”微信小程序，快捷登录：https://dllzff.cn/HbUCGVWg`;
            return myRemark;
        },
    },
    created() {
        this.$validator.remove("telchk");
        this.$validator.extend("telchk", {
            validate: value => {
                const reg = /^1[3456789]\d{9}$/;
                return reg.test(value)
            }
        });
    },
    methods: {
        getMyCode() {
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        console.log('count',this.count)
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
                this.getCode();
            }
        },
        close() {
            this.$emit('hideSend');
        },
        submitInfo() {
            this.$validator
                .validateAll()
                .then((result) => {
                    if (result) {
                        this.save();
                    }
                })
                .catch(err => {});
        },
        getCode() {
            if (!this.model.phone) {
                this.$message.error('手机号不能为空');
                return false;
            }
            if (this.model.phone.length != 11) {
                this.$message.error('手机号输入有误，请重新输入');
                return false;
            }
            this.$axios.post(`/user/sendBindCode`, {
                "phone": this.model.phone
            }).then(res => {
                let data = this.AppUtils.checkResponse(res);
                if (data) {
                    if (data.code == 0) {
                        this.$message.success('发送成功');
                    } else {
                        this.$message.error(data.msg)
                    }
                }
            });
        },
        save() {
            let _this = this;
            if (!this.model.code) {
                this.$message.error('验证码不能为空');
                return false;
            }
            if (this.model.code.length != 6) {
                this.$message.error('验证码输入有误，请重新输入');
                return false;
            }
            this.$axios.post(`/user/bindPhone`, this.model).then(res => {
                let data = this.AppUtils.checkResponse(res);
                if (data) {
                    if (data.code == 0) {
                        this.$message.success('绑定成功');
                        var infos = data.data;
                        _this.$store.commit("TOKEN_INIT", {
                            token: infos.token
                        });
                        localStorage.setItem('userinfos', JSON.stringify(infos));
                        if (infos.token) {
                            localStorage.setItem('token', infos.token)
                            this.AppUtils.setCookie("token", infos.token);
                            _this.$store.commit("ONLINE_STATUS", infos.onlineStatus);
                        }
                        let menus = infos.userRoles;
                        if (menus && menus.length == 1 && menus[0].roleId == 40) {
                            this.$router.push('/workPlat120');
                            return false;
                        }

                        this.$router.push('/workPlat');
                    } else {
                        this.$message.error(data.msg)
                    }
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
/*@import '../../assets/css/cover.css';*/
.systemUl {
    display: flex;

    .systemLi {
        width: 100px;
        line-height: 30px;
        text-align: center;

    }
}

.reset {
    position: relative;
    left: -30px;
}

.mask-layer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.form_item {
    display: flex;
    justify-content: center;
    /*margin-bottom: 15px;*/
}

.form_left {
    line-height: 32px;
    margin-right: 10px;
    display: flex;
    align-items: center;
}

.form_right {
    line-height: 32px;
    width: 200px !important;
    box-sizing: border-box;
    padding-left: 10px;
    text-align: left;
    height: 48px;
    margin-left: 26px;
}

.container {
    background-color: #fff;
    width: 600px;
    box-sizing: border-box;
    padding-bottom: 10px;
    max-height: 650px;
    position: relative;
    overflow-y: scroll;

    .close {
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        position: absolute;
        top: 10px;
        right: 5px;
        cursor: pointer;
    }

    .title {
        height: 41px;
        line-height: 41px;
        box-sizing: border-box;
        padding-left: 16px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #4A4A4A;
        text-align: left;
        border-bottom: 1px solid #ECF1F4;
    }

    .content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        /* justify-content: flex-end; */
        align-items: flex-start;
        box-sizing: border-box;
        padding-left: 100px !important;

        .topInfo {
            display: flex;
            justify-content: left;
            margin-bottom: 27px;

            span {
                line-height: 21px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #000000;
            }
        }

        .sendInfo {
            display: flex;
            justify-content: left;
            margin-bottom: 10px;

            span {
                line-height: 21px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #000000;
            }
        }

        .infoZone {
            width: 568px;
            height: 250px;
            border: 1px solid #D7D7D7;
            border-radius: 2px;
            position: absolute;
            text-align: left;
            box-sizing: border-box;
            padding: 11px 20px;

            p {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #4A4A4A;

                a {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #FF4C00;
                }
            }

            .p1 {
                margin-bottom: 25px;
            }

            .p2 {
                margin-bottom: 11px;
            }

            .p3 {
                margin-bottom: 7.5px;
            }

            textarea {
                position: absolute;
                left: 0;
                top: 0px;
                width: 100%;
                height: 100%;
                resize: none;
                box-sizing: border-box;
                /*padding: 0px 22px;*/
            }

            button {
                position: absolute;
                right: 14px;
                bottom: 9.5px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #FFFFFF;
                background: #1038B7;
                border-radius: 2px;
                padding: 2px 12px;
            }
        }
    }
}

.btn {
    margin-left: 20px !important;
    min-width: 87px!important;
}

.myRight {
    .myPhone {
        width: 250px;
        padding: 0 10px;
        height: 30px;
        border-radius: 3px !important;
        border: 1px solid #DCDFE6;
        background-attachment: #fff;
        color: #191818;
    }

    .myCode {
        width: 144px;
        padding: 0 10px;
        height: 30px;
        border-radius: 3px !important;
        border: 1px solid #DCDFE6;
        background-attachment: #fff;
        color: #191818;
    }
}
</style>



// WEBPACK FOOTER //
// sendMessage.vue?ba5a8158